module.exports = __webpack_public_path__ + "img/newsbanner.47533561.jpg";